import { elementScrollIntoView } from 'seamless-scroll-polyfill';

/**
 * Detect if the browser is Safari
 */
export const isSafari = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
};

/**
 * Scroll an element into view with smooth behavior
 * Chrome seems to only work sporadically if not in a timeout
 * Safari's built-in el.scrollIntoView doesn't support the options so use the polyfill directly
 */
export const scrollTo = (
  el: HTMLElement,
  config: ScrollIntoViewOptions,
  parent?: HTMLElement | null
): void => {
  setTimeout(() => {
    if (isSafari()) {
      elementScrollIntoView(el, config);
    } else {
      // In certain scenarios there can be many carousels embedded in each other, so we need to
      // have the parent explicitly scroll to the given element's position
      if (parent) {
        parent.scroll({ left: el.offsetLeft, behavior: 'smooth' });
      } else {
        el.scrollIntoView(config);
      }
    }
  });
};
